import styled from "styled-components";

export const NavArea = styled.header`
  height: 12vh;
  display: flex;
  align-items: center;
`;

export const LogoImage = styled.img`
  width: 120px;
  cursor: pointer;
`;

export const SubTitle = styled.p`
  margin: 0 30px;
`;
